import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button'];

  butNotTwice() {
    this.buttonTarget.setAttribute('disabled', true);
  }
}
